import * as systemActions from '../../systemManager/systemActions'
import * as workorderActions from '../workorderActions'

import DispatchBar from './dispatchBar'
import NewIcon from '@mui/icons-material/NoteAdd'
import React from 'react'
import { TrackJS } from 'trackjs'
import { bindActionCreators } from 'redux'
import {buttonPrototype} from '../../commonComponents/buttonBar'
import { connect } from 'react-redux'
import errorConstants from '../../lib/errorConstants'
import workorderValidator from '../workorderValidator'

function mapStateToProps(state, ownProps) {
    return {
        currentProducts: state.product.currentProducts,
        stateStore: state,
        workorderName: state.workorder.workorderName,
        workorderUuid: state.workorder.workorderUuid,
        fieldDisplayArea: state.scout.fieldDisplayArea,
        fieldAreaDisplayUnit: state.scout.fieldAreaDisplayUnit,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        ...bindActionCreators(workorderActions, dispatch),
        ...bindActionCreators(systemActions, dispatch),
    }
}
class JobProcessing extends React.Component {

    static defaultProps = {
        onReset: () => {},
        onTemplate: () => {},
        onValidationFailed: () => {},
        saved: false,
        disabled: false, // for the entire bar, overrides other disabled states
    }
    constructor(props) {
        super(props)
        this.state = {
            message: '',
            validationErrors: [],
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.workorderUuid !== this.props.workorderUuid) {
            this.setState({
                message: '',
                validationErrors: [],
            })
        }
    }

    saveWorkorder = async() => {
        const workorder = {
            products: this.props.currentProducts,
            workorderName: this.props.workorderName,
            fieldDisplayArea: this.props.fieldDisplayArea,
            fieldAreaDisplayUnit: this.props.fieldAreaDisplayUnit,
        }
        const {isValid, errors} = workorderValidator.validateWorkorder(workorder)

        if (!isValid) {
            this.setState({message: '', validationErrors: errors})
            this.props.onValidationFailed(workorderValidator.errorSteps(errors))

            return false
        }

        this.setState({message: '', validationErrors: []})

        const rVal = await this.props.saveWorkorder(this.props.stateStore)
        if (rVal.error) {
            TrackJS.console.debug(this.props.stateStore)

            let message
            switch (rVal.errorCode) {
                case 401:
                    message = errorConstants.accessUnauthorizedErrorMessage
                    break

                case 403:
                    message = errorConstants.accessForbiddenErrorMessage
                    break

                case 409:
                    message = errorConstants.duplicateEntryErrorMessage
                    break

                case 500:
                    message = errorConstants.internalServerErrorMessage
                    break

                default:
                    message = errorConstants.genericErrorMessage
            }
            TrackJS.track(`Failed to save job: ${message}`)
            this.setState({message: `Save failed: ${message} ${errorConstants.clickResetMessage}`})
        }
        else {
            this.props.onSaved()
            this.setState({message: 'Job saved successfully'})
        }

        return rVal
    }


    renderValidationMessages() {
        if (this.state.validationErrors.length > 0) {
            return (
                <ul name="validationSummary" style={{color: 'red', margin: 0}}>
                    {workorderValidator.summaryMessages(this.state.validationErrors).map((msg, index) => (
                        <li key={index}>{msg}</li>
                    ))}
                </ul>
            )
        }

        return <div style={{color: 'red'}}>{this.state.message}</div>
    }

    render() {

        return (
            <div name="jobCreateBar">
                <DispatchBar
                    cloudCheckboxDisabled={this.props.saved}
                    releasedTime={this.props.saved ? this.props.releasedTime : Date.now()}
                    archived={false}
                    disabled={this.props.disabled}
                    frontChildren={[
                        buttonPrototype({
                            label: 'Save',
                            onClick: this.saveWorkorder,
                            iconPath: `jobIcons/Job_SaveWhite`,
                            mobileIconPath: `jobIcons/Job_SaveBlue`,
                            disabledIconPath: `jobIcons/Job_SaveDisabled`,
                            disabled: this.props.saved,
                        }),
                    ]}
                    backChildren={[
                        buttonPrototype({
                            label: 'Reset',
                            icon: <NewIcon />,
                            iconStyle: {fill: 'var(--primary)'},
                            disabledIconStyle: {fill: '#AEAEAE'},
                            onClick: this.props.onReset,
                        }),
                    ]}
                    templateOverrides={{
                        label: 'Create Another',
                        onClick: this.props.onTemplate,
                        disabled: !this.props.saved,
                    }}

                    saved={this.props.saved}
                    validateAndSaveWorkorder={this.saveWorkorder}
                />
                {this.renderValidationMessages()}
            </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(JobProcessing)
